import { Loader } from './styled';

function RLoader() {
  return <Loader>{/* <AppLogoSvg /> */}</Loader>;
}

export { RLoader };
